import { useMemo, useState } from 'react';

import cx from 'classnames';

import { helperTextStyle, inputStyle as inputStyleClass } from './Survey.css';
import type { Question } from './Survey.types';
import { getInputStyle } from './utils';

interface Props {
  question: Question;
  inputStyle?: React.CSSProperties;
}

const LongText = ({ question, inputStyle = {} }: Props) => {
  const [charCount, setCharCount] = useState(0);
  const maxCharacterLimit = question.max_character_limit ? Math.min(1000, question.max_character_limit) : 400;

  const isRequired = question.required || question.min_character_limit > 0;

  const style = useMemo(() => getInputStyle(inputStyle), [inputStyle]);

  return (
    <>
      <textarea
        className={inputStyleClass}
        style={style}
        maxLength={maxCharacterLimit}
        minLength={question.min_character_limit}
        name={question.field_name || question.id}
        id={question.id}
        required={isRequired}
        placeholder={question.placeholder || 'Please type your response here'}
        onChange={(e) => setCharCount(e.target.value.length)}
      />
      {question.min_character_limit > 0 && (
        <span className={cx(helperTextStyle, 'mr-1')}>
          Minumum entry size of {question.min_character_limit} characters.
        </span>
      )}
      <span>
        <span className={helperTextStyle}>Characters remaining: {maxCharacterLimit - charCount}</span>
      </span>
    </>
  );
};

export default LongText;
